// Types for Coin Liquidation functionality
export enum TypeLiquidation {
  GLOBAL = 'global',
  CUSTOM = 'custom',
}

export enum TargetCoinLiquidation {
  USDC = 'USDC',
  USDT = 'USDT',
  NATIVE = 'NATIVE',
}

export enum TabLiquidation {
  SELL_ALL = 'SELL_ALL',
  REDEPLOY = 'REDEPLOY',
}

export interface CustomToken {
  contract_address: string
  address: string
  name: string
  symbol: string
  balance: string
  decimals: number
  cmcCoinId: number
  network: NetworkConfig
  isNative: boolean
  stringBalance: number | string
  USDBalance: number
  stringUSDBalance: number | string
  isMatch?: boolean
  isCustom?: boolean
  logo?: string
  isShowUSD?: boolean
}

export interface NetworkConfig {
  name: string
  rpc: string
  chainId: any
  chainIdHex: any
  explorer: string
  queryToken: string
  symbol: string
  baseCoin: string
  cmcCoinId: number
  extension: string
  decimals: number
  transactionPath: string
  logo: any
  farmToken?: string
  nativeCurrency?: {
    symbol: string
    cmcCoinId: number
    name: string
  }
  publicRPC: string
  logoUrl?: string
  fallBack?: string
}

export type LiquidationAsset = CustomToken & {
  nativeCurrency: {
    name: string
    symbol: string
    cmcCoinId: number
  }
  balanceString: string
  isSelected: boolean
  address: string
  loading: boolean
  allocation: number
  price: string
  error: string
}

export type AnyTxStatus = -1 | 0 | 1
export type AnyTXType =
  | 'SWAP'
  | 'SEND'
  | 'POOL'
  | 'REMOVE POOL'
  | 'BRIDGE'
  | 'WALLET_CONNECT'
  | 'PARA_SWAP'

export interface AnyTx {
  hash?: string
  status: AnyTxStatus
  sendSymbol?: string
  sendLogo?: string
  receiveSymbol?: string
  receiveLogo?: string
  sendValue: string
  receiveValue?: string
  exchangeRate?: string
  date: string | Date
  txType?: AnyTXType
  receiveAddress?: string
  to?: string
  network?: string
  transactionId?: string
  walletConnectRequestID?: number
  from?: string
  amountAsUSD?: string
  amountOutAsUSD?: string
  tokenAddress?: string[]
  indicateAddress?: string
}

// Window interface for MetaMask - using type assertion instead of global declaration
export interface EthereumProvider {
  request: (args: { method: string; params?: any[] }) => Promise<any>
  selectedAddress?: string
}

// BuyBack types
export interface BuyBackItem {
  id: string // Unique ID for this buyback item
  timestamp: number
  inputToken: {
    symbol: string
    name: string
    address: string
    decimals: number
    chainId: number
    networkName: string
    isNative: boolean
  }
  outputToken: {
    symbol: string
    name: string
    address: string
    decimals: number
    chainId: number
    networkName: string
    isNative: boolean
  }
  soldAmountUSD: number // USD amount sold (inputToken)
  receivedAmountUSD: number // USD amount received (outputToken) - may be different due to slippage
  buybackAmountUSD: number // USD amount to buy back (same as soldAmountUSD)
  soldAmount: string // Actual token amount sold
  receivedAmount: string // Actual token amount received
  txHash?: string // Transaction hash of the sell
  // Note: status is not persisted - it's only UI state
}

export interface BuyBackHistory {
  walletAddress: string
  items: BuyBackItem[]
  createdAt: number
  updatedAt: number
}
